import { CmsConverterService } from '../../../cms/services/cms-converter/cms-converter.service'
import { Injectable } from '@angular/core'
import { CmsComponent } from '@spartacus/core'
import { TrainingDescriptionComponentData } from './index'

@Injectable({ providedIn: 'root' })
export class TrainingDescriptionConverter extends CmsConverterService<TrainingDescriptionComponentData> {

  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      trainingId: formData.st_training_id?.value,
      hideRegisterButton: formData.st_hide_registration?.value,
    }
  }
}
